import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-duplicate-question-dialog-error',
    templateUrl: './duplicate-question-dialog-error.component.html',
})
export class DuplicateQuestionErrorDialogComponent implements OnInit {
    languages: string[] = [];
    constructor(
        public dialogRef: MatDialogRef<DuplicateQuestionErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        const duplicateQuestions = this.data?.meta?.duplicate_questions;
        this.languages = Object.keys(duplicateQuestions) || [];
    }

    close(): void {
        this.dialogRef.close();
    }
}
